// import React, { Component } from 'react';
// import Cookies from 'universal-cookie';
// import Header from '../components/dashboardSubComponents/header'
// import SideBar from '../components/dashboardSubComponents/sideBarNav'
// import { Loader } from 'react-overlay-loader';
// import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
// import { url, logout } from '../components/helper'
// const preview = require('../CSS/images/preview.png')

// class CreateOrganization extends Component {

//     constructor(props) {
//         super(props)
//         this.state = {
//             org_name: "",
//             org_days: 7,
//             btn_disabled: true,
//             loading: false,
//             message_title: "",
//             message_body: "",
//             message_type: 1,
//             message_box_open: false,
//             FileErrorHidden: true
//         }
//         this.handleNameInputChange = this.handleNameInputChange.bind(this)
//         this.handleDaysInputChange.bind(this)
//         this.create_organization = this.create_organization.bind(this)
//         this.OpenFileBrowser = this.OpenFileBrowser.bind(this)
//         this.changePreviewImg = this.changePreviewImg.bind(this)
//         this.hasExtension = this.hasExtension.bind(this)
//     }

//     componentWillMount = () => {
//         var cookies = new Cookies();
//         var loginStatus = cookies.get('loggedIn')
//         if (loginStatus === undefined) {
//             window.location = '/login'
//         }
//         var branch_admin = cookies.get('branch-admin')
//         var organization_admin = cookies.get('organization-admin')

//         if (branch_admin === 'true' || organization_admin === 'true' || cookies.get('branch-user') === "true") {
//             window.location = '/dashboard'
//         }

//     }

//     create_organization = (event) => {
//         event.preventDefault()
//         // var form = document.getElementById('orgData');
//         // // //(form)
//         // var formData = new FormData(form);
//         // //(formData)
//         this.setState({
//             loading: true
//         })
//         var cookies = new Cookies();
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')
//         var global_ref = this
//         var fileInput = document.getElementById('logo');
//         var nameInput = document.getElementById('org_name').value
//         var file = fileInput.files[0];
//         var formData = new FormData();
//         formData.append('org_logo', file);
//         formData.append('org_name', nameInput);
//         formData.append('days', this.state.org_days)
//         var http = new XMLHttpRequest();
//         http.open('POST', url + '/api/organisation?user_id=' + user_id, true);
//         http.setRequestHeader("Authorization", "Bearer " + token);
//         http.send(formData);
//         http.onreadystatechange = function () {
//             if (http.readyState === 4 && http.status === 200) {
//                 var json = JSON.parse(http.responseText)
//                 if (json.status === 200) {
//                     global_ref.setState({
//                         loading: false,
//                         message_title: "Success",
//                         message_body: "Organization has been created successfully",
//                         message_type: 1,
//                         message_box_open: true
//                     })
//                 }
//                 else {
//                     global_ref.setState({
//                         loading: false,
//                         message_title: "Error",
//                         message_body: "Organization has could not be created",
//                         message_type: 2,
//                         message_box_open: true
//                     })
//                 }
//             }
//             if (http.readyState === 4 && http.status === 401) {
//                 logout()
//             }

//         }
//         http.ontimeout = function () {
//             global_ref.setState({
//                 loading: false,
//                 message_title: "Timeout",
//                 message_body: "Request has timed out. Please Try again",
//                 message_type: 2,
//                 message_box_open: true
//             })
//         }
//         http.onerror = function () {
//             global_ref.setState({
//                 loading: false,
//                 message_title: "Error",
//                 message_body: "Server encountered an error. Please try again",
//                 message_type: 2,
//                 message_box_open: true
//             })
//         }

//     }

//     handleNameInputChange = () => {

//         var input = document.getElementById('org_name').value
//         this.setState({
//             org_name: input
//         }, function () {
//             if (this.state.org_name !== '') {
//                 this.setState({ btn_disabled: false })
//             }
//         })
//     }

//     handleDaysInputChange = () => {
//         var input = document.getElementById("org_days").value
//         this.setState({
//             org_days: input
//         })
//     }

//     close_message_box_modal = () => {
//         if (this.state.message_type === 1) {
//             this.setState({
//                 message_box_open: false
//             })
//             window.location = "/view-organization"
//         }
//         if (this.state.message_type === 2) {
//             this.setState({
//                 message_box_open: false
//             })
//         }
//     }

//     hasExtension = (inputID, exts) => {
//         var fileName = document.getElementById(inputID).value;
//         return (new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$')).test(fileName);
//     }

//     OpenFileBrowser = () => {
//         var elem = document.getElementById('logo');
//         if (elem && document.createEvent) {
//             var evt = document.createEvent("MouseEvents");
//             evt.initEvent("click", true, false);
//             elem.dispatchEvent(evt);
//         }

//     }

//     changePreviewImg = () => {
//         //('selected')
//         var input = document.getElementById('logo')
//         if (!this.hasExtension('logo', ['.jpg', '.png', '.bmp', '.JPG', '.PNG', '.BMP'])) {
//             this.setState({
//                 FileErrorHidden: false,
//                 message_body: "This file format is not supported. Only PNG, JPG and BMP files are allowed"
//             })
//             setTimeout(function () {
//                 this.setState({
//                     FileErrorHidden: true,
//                 })
//             }.bind(this), 2000)
//             return
//         }

//         if (input.files && input.files[0]) {
//             //("not here")
//             var reader = new FileReader();

//             reader.onload = function (e) {
//                 //(e.target.result)
//                 document.getElementById('logoThumbnail').setAttribute('src', e.target.result)
//             };

//             reader.readAsDataURL(input.files[0]);
//             this.setState({
//                 FileErrorHidden: true,
//             })
//         }
//     }

//     render() {
//         return (
//             <div>
//                 <Loader loading={this.state.loading} fullPage={true} />
//                 <Modal isOpen={this.state.message_box_open}>
//                     <ModalHeader>{this.state.message_title}</ModalHeader>
//                     <ModalBody>{this.state.message_body}</ModalBody>
//                     <ModalFooter><Button color="primary" onClick={this.close_message_box_modal}>Close</Button></ModalFooter>
//                 </Modal>
//                 <div className="clearfix" id="page-header">
//                     <div>
//                         <Header />
//                     </div>
//                 </div>

//                 <div >
//                     <SideBar isActive="org" />
//                 </div>

//                 <div id="page-content-wrapper" className="rm-transition">
//                     <div id="page-content">

//                         <div className="row">
//                             <div className="col-md-4"></div>
//                             <div className="col-md-4"><h2 style={{ marginLeft: 100 }}>Create Organization</h2></div>
//                             <div className="col-md-4"></div>
//                         </div>

//                         <div className="row" style={{ marginTop: 30 }}>
//                             <div className="col-md-2"></div>
//                             <div className="col-md-8">
//                                 <form id="orgData">
//                                     <div class="form-group">
//                                         <label ><h3>Organization Name</h3></label>
//                                         <input type="text" class="form-control" id="org_name" value={this.state.org_name} placeholder="Enter organization name" onChange={this.handleNameInputChange} maxLength="40"></input>
//                                     </div>
//                                     <div class="form-group">
//                                         <label><h3>Days To Delete Photos After</h3></label>
//                                         <input type="number" class="form-control" id="org_days" value={this.state.org_days} placeholder="Specify number of days after which photos will be delete from the device" onChange={this.handleDaysInputChange}></input>
//                                     </div>
//                                     <div class="form-group ">
//                                         <div class="thumbnail">
//                                             {/* <img id='logoThumbnail' src="https://via.placeholder.com/200x200.png?text=Preview" alt=""></img> */}
//                                             <img id='logoThumbnail' src={preview} alt=""></img>

//                                             <h3 onClick={this.OpenFileBrowser}>Choose Logo</h3>
//                                             <input type="file" id="logo" hidden={true} onChange={this.changePreviewImg} />
//                                         </div>
//                                         <p class="isa_error" hidden={this.state.FileErrorHidden}><i class="fa fa-times-circle"></i>{this.state.message_body}</p>
//                                     </div>

//                                     <button type="submit" className="btn btn-block btn-primary" onClick={this.create_organization} max-width='100%' disabled={this.state.btn_disabled}>Create Organization</button>
//                                 </form>
//                             </div>
//                             <div className="col-md-2"></div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         )
//     }
// }

// export default CreateOrganization;

import React from 'react'
import { Loader } from 'react-overlay-loader'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import Cookies from 'universal-cookie'
import Header from '../components/dashboardSubComponents/header'
import SideBar from '../components/dashboardSubComponents/sideBarNav'
import { logout, url } from '../components/helper'
const preview = require('../CSS/images/preview.png')

const CreateOrganization = () => {
    const [orgName, setOrgName] = React.useState('')
    const [orgDays, setOrgDays] = React.useState(7)
    const [btnDisabled, setBtnDisabled] = React.useState(true)
    const [loading, setLoading] = React.useState(false)
    const [messageTitle, setMessageTitle] = React.useState('')
    const [messageBody, setMessageBody] = React.useState('')
    const [messageType, setMessageType] = React.useState(1)
    const [messageBoxOpen, setMessageBoxOpen] = React.useState(false)
    const [fileErrorHidden, setFileErrorHidden] = React.useState(true)

    const handleNameInputChange = () => {
        const input = document.getElementById('org_name').value
        setOrgName(input)
        if (input !== '') {
            setBtnDisabled(false)
        }
    }

    //Updates days input onChange
    const handleDaysInputChange = () => {
        const input = document.getElementById('org_days').value
        setOrgDays(input)
    }

    //Close message box modal based on message type
    const closeMessageBoxModal = () => {
        if (messageType === 1) {
            setMessageBoxOpen(false)
            window.location = '/view-organization'
        }
        if (messageType === 2) {
            setMessageBoxOpen(false)
        }
    }

    //All file selection
    const openFileBrowser = () => {
        const elem = document.getElementById('logo')
        if (elem) {
            const evt = document.createEvent('MouseEvents')
            evt.initEvent('click', true, false)
            elem.dispatchEvent(evt)
        }
    }

    //Change the preview image when image is uploaded
    const changePreviewImg = () => {
        const input = document.getElementById('logo')

        //Checks if the extension on the file is valid
        if (
            !hasExtension('logo', [
                '.jpg',
                '.png',
                '.bmp',
                '.JPG',
                '.PNG',
                '.BMP',
            ])
        ) {
            setFileErrorHidden(false)
            setMessageBody(
                'This file format is not supported. Only PNG, JPG and BMP files are allowed'
            )
            setTimeout(() => {
                setFileErrorHidden(true)
            }, 2000)
            return 0
        }

        if (input.files && input.files[0]) {
            const reader = new FileReader()
            reader.onload = (e) => {
                document
                    .getElementById('logoThumbnail')
                    .setAttribute('src', e.target.result)
            }
            reader.readAsDataURL(input.files[0])
            setFileErrorHidden(true)
        }
    }

    //Checks if the file has a valid extension
    const hasExtension = (inputID, exts) => {
        const fileName = document.getElementById(inputID).value
        const re_file = new RegExp(
            '(' + exts.join('|').replace(/\./g, '\\.') + ')$'
        )
        return re_file.test(fileName)
    }

    //Preliminary check on credentials
    const credentialCheck = () => {
        const cookies = new Cookies()

        const token = cookies.get('token')
        if (!token) {
            window.location = '/login'
        }

        const branchAdmin = cookies.get('branch-admin')
        const organizationAdmin = cookies.get('organization-admin')
        const branchUser = cookies.get('branch-user')
        if (
            branchAdmin === 'true' ||
            organizationAdmin === 'true' ||
            branchUser === 'true'
        ) {
            window.location = '/dashboard'
        }
    }

    //Handle Organisation Creation
    const createOrganization = async (event) => {
        event.preventDefault()
        setLoading(false)

        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')
        const fileInput = document.getElementById('logo')
        const nameInput = document.getElementById('org_name').value
        const file = fileInput.files[0]
        const formData = new FormData()

        formData.append('org_logo', file)
        formData.append('org_name', nameInput)
        formData.append('days', orgDays)

        const options = {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        }

        try {
            const res = await fetch(
                `${url}/api/organisation?user_id=${userId}`,
                options
            )
            const data = await res.json()

            // console.log('RES', res)
            // console.log('DATA', data)

            switch (data.status) {
                case 200:
                    setLoading(false)
                    setMessageTitle('Success')
                    setMessageBody('Organization has been created successfully')
                    setMessageType(1)
                    setMessageBoxOpen(true)
                    break
                case 401:
                    logout()
                    break
                default:
                    setLoading(false)
                    setMessageTitle('Error')
                    setMessageBody('Organization could not be created')
                    setMessageType(2)
                    setMessageBoxOpen(true)
                    break
            }
        } catch (err) {
            setLoading(false)
            setMessageTitle('Error')
            setMessageBody('Server encountered an error. Please try again')
            setMessageType(2)
            setMessageBoxOpen(true)
        }
    }

    React.useEffect(() => {
        credentialCheck()
    }, [])

    return (
        <div>
            <Loader loading={loading} fullPage={true} />
            <Modal isOpen={messageBoxOpen}>
                <ModalHeader>{messageTitle}</ModalHeader>
                <ModalBody>{messageBody}</ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={closeMessageBoxModal}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
            <div className="clearfix" id="page-header">
                <div>
                    <Header />
                </div>
            </div>

            <div>
                <SideBar isActive="org" />
            </div>

            <div id="page-content-wrapper" className="rm-transition">
                <div id="page-content">
                    <div className="row">
                        <div className="col-md-4"></div>
                        <div className="col-md-4">
                            <h2 style={{ marginLeft: 100 }}>
                                Create Organization
                            </h2>
                        </div>
                        <div className="col-md-4"></div>
                    </div>

                    <div className="row" style={{ marginTop: 30 }}>
                        <div className="col-md-2"></div>
                        <div className="col-md-8">
                            <form id="orgData">
                                <div class="form-group">
                                    <label>
                                        <h3>Organization Name</h3>
                                    </label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="org_name"
                                        value={orgName}
                                        placeholder="Enter organization name"
                                        onChange={handleNameInputChange}
                                        maxLength="40"
                                    ></input>
                                </div>
                                <div class="form-group">
                                    <label>
                                        <h3>Days To Delete Photos After</h3>
                                    </label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        id="org_days"
                                        value={orgDays}
                                        placeholder="Specify number of days after which photos will be delete from the device"
                                        onChange={handleDaysInputChange}
                                    ></input>
                                </div>
                                <div class="form-group ">
                                    <div class="thumbnail">
                                        {/* <img id='logoThumbnail' src="https://via.placeholder.com/200x200.png?text=Preview" alt=""></img> */}
                                        <img
                                            id="logoThumbnail"
                                            src={preview}
                                            alt=""
                                        ></img>

                                        <h3 onClick={openFileBrowser}>
                                            Choose Logo
                                        </h3>
                                        <input
                                            type="file"
                                            id="logo"
                                            hidden={true}
                                            onChange={changePreviewImg}
                                        />
                                    </div>
                                    <p
                                        class="isa_error"
                                        hidden={fileErrorHidden}
                                    >
                                        <i class="fa fa-times-circle"></i>
                                        {messageBody}
                                    </p>
                                </div>

                                <button
                                    type="submit"
                                    className="btn btn-block btn-primary"
                                    onClick={createOrganization}
                                    max-width="100%"
                                    disabled={btnDisabled}
                                >
                                    Create Organization
                                </button>
                            </form>
                        </div>
                        <div className="col-md-2"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateOrganization

/**
 * Notes:
 * - Some handle functions redundant, can be done in as anon functions
 * - InitEvent is deprecated, need to shift (AddEventListeners?)
 * - HasExtentions seems unnecessarily complicated with the reg check
 * - changePreviewImg, confusing, no idea what is doing besides uploading image content
 * - Onerror check required
 */



// WEBPACK FOOTER //
// src/Routes/CreateOrganization.js